var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8760_3529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8002 1.13328L14.8669 0.199951L8.0002 7.06662L1.13353 0.199951L0.200195 1.13328L7.06686 7.99995L0.200195 14.8666L1.13353 15.8L8.0002 8.93328L14.8669 15.8L15.8002 14.8666L8.93353 7.99995L15.8002 1.13328Z",
    fill: "#031434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8760_3529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearSearchIcon);
export default __webpack_public_path__ + "static/media/clear_search_icon.18c92114395efebacb730f9d847f6d98.svg";
export { ForwardRef as ReactComponent };